import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GlobalConfigDTO} from '../dto/global-config';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/config';

  getConfig(): Observable<GlobalConfigDTO> {
    return this.http.get<GlobalConfigDTO>(this.apiUrl);
  }
}
